module.exports = __webpack_public_path__ + "ECMv6/static/media/Saviynt-logo-white.7a3ee200.svg";